import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
Vue.use(ElementUI);

import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

// import 'lib-flexible'
import './utils/flexible'
// window.onload=function(){
//   document.body.style.zoom="100%";
// }
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
